import type { LucideIcon } from 'lucide-react';

type Tone = 'default' | 'brand' | 'warning' | 'danger';

const TONE: Record<Tone, string> = {
  default: 'text-n-500 hover:bg-n-100 hover:text-n-800',
  brand: 'text-n-500 hover:bg-brand-50 hover:text-brand-600',
  warning: 'text-n-500 hover:bg-warning-50 hover:text-warning-700',
  danger: 'text-n-500 hover:bg-danger-50 hover:text-danger-600',
};

interface Props {
  icon: LucideIcon;
  /** Tooltip + aria-label (a ação não tem texto visível). */
  label: string;
  onClick: () => void;
  tone?: Tone;
  disabled?: boolean;
}

/**
 * Botão-ícone padrão pras colunas "Ações" das tabelas (Contatos/Canais e agora
 * as tabelas de Configurações). 30×30, ícone lucide 14px strokeWidth 1.75,
 * hover colorido por tom. Sem texto — `label` vira title + aria-label.
 */
export function ActionIconButton({
  icon: Icon,
  label,
  onClick,
  tone = 'default',
  disabled,
}: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      title={label}
      className={`inline-flex h-[30px] w-[30px] items-center justify-center rounded-[6px] transition disabled:cursor-not-allowed disabled:opacity-40 ${TONE[tone]}`}
    >
      <Icon size={14} strokeWidth={1.75} aria-hidden="true" />
    </button>
  );
}
